<template>
    <div class="modal-article">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                      <el-row class="row">
                        <el-col :span="12" class="item">
                          <div class="label">图标</div>
                          <el-upload
                              action=""
                              :limit="1"
                              :on-preview="handlePictureCardPreview"
                              :on-change="handleChange"
                              :on-progress="onProgress"
                              :on-success="imgSuccess"
                              :on-error="imgError"
                              :http-request="uploadHttp"
                              list-type="picture-card"
                              :on-remove="handleRemove"
                              :class="{disabled:uploadDisabled}"
                              :file-list="fileList">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                          <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
                            <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
                          </el-dialog>

                        </el-col>
                      </el-row>
                        <el-row>
                             <el-col :span="24" class="item">
                                <el-form-item label="标题" required prop="title">
                                    <el-input v-model="addForm.title"  placeholder="请输入标题"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24" class="item">
                                <el-form-item label="简介" required prop="description">
                                    <el-input type="textarea" :rows="2" v-model="addForm.description" placeholder="请输入简介"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="内容" required prop="content">
                                    <Quill placeholder='请输入详情' v-model='addForm.content' editorRef='addQuill' @input="handelIncrease"></Quill>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Quill from "@/components/Quill";

    export default {
        name: 'Add',
        props: ['type2'],
        data() {
            return {
                imageUrl:'',
                loading: false,
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadUrl1:this.$shopUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    title:"",
                    description:"",
                    content:"",
                  type:'',
                  headImg:'',
                },
                //fileList:[],
                zoneList:null,
                rules:{
                    title:[
                        { required: true, message: '请输入标题', trigger: 'blur' },
                    ],
                    description:[
                        { required: true, message: '请输入简介', trigger: 'blur' },
                    ],
                    content:[
                        { required: true, message: '请填写内容', trigger: 'blur' },
                    ]
                },
                options:{
                    value:'articleClassCode',
                    label:'name',
                    children:'articleClassList',
                    emitPath:false
                },

              //上传身份证正面相关参数
              limitCount: 1,
              uploadDisabled: false,
              // 是否显示预览图片
              imgVisible: false,
              // 预览图片url
              dialogImageUrl: "",
              fileList: [],


            }
        },
        components:{Quill},
        methods: {


          onProgress(event, file, fileList) {
            console.log(event,file,fileList);
            this.uploadDisabled = false;
          },
          // 图片上传成功
          imgSuccess(response, file, fileList) {
            console.log(response,file,fileList);
            this.uploadDisabled = true;
          },
          // 图片上传失败
          imgError(err, file, fileList) {
            console.log(err,file,fileList);
            this.uploadDisabled = true;
          },
          // 预览图片
          handlePictureCardPreview(file) {
            this.imgVisible = true;
            this.uploadDisabled = true;
            this.dialogImageUrl = file.url;
          },
          // 删除图片
          handleRemove(file, fileList) {
            console.log(file,fileList);
            this.uploadDisabled = false;
          },
          //图片更改
          handleChange(fileList) {
            this.uploadDisabled = fileList.length >= this.limitCount;
            this.uploadDisabled = true;
          },

          uploadHttp(file) {

            //获取文件信息
            //let fileLen = file.file;
            //let name = fileLen.name

            let fd = new FormData();
            fd.append('file',file.file);
            fd.append('staffCode',getStaffCode());
            fd.append('timeStr',timeStr);
            fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
            let that = this;
            this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
              console.log(res.data);
              that.addForm.headImg = res.data.data.path;
            })


          },


            init(){
                this.$refs.addForm.resetFields();
                this.addForm.startTime=''
                this.addForm.endTime='',
                    this.addForm.type = this.type2;
            },
            dataChange(val) {
                this.addForm.startTime = val[0]
                this.addForm.endTime = val[1]
            },
            handleOpen(file){
                let url=this.$imgUrl+file.url
                let suffix=file.url.slice(file.url.lastIndexOf('.')+1,file.url.length)
                if(suffix.toLowerCase()!='pdf'){
                    url="https://view.officeapps.live.com/op/view.aspx?src="+this.$imgUrl+file.url
                }
                window.open(url)
            },
            beforeUpload(file) {
                let suffix=file.name.slice(file.name.lastIndexOf('.')+1,file.name.length)
                if (['mp4', 'mp3', 'doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(suffix.toLowerCase()) == -1) {
                    this.$message.error('请上传正确格式的文件！')
                    return false
                }
            },
            handleDownload(file){
                let url=file.url
                let fileName = file.name;
                let suffix=file.url.slice(file.url.lastIndexOf('.')+1,file.url.length)
                if(suffix.toLowerCase()=='pdf'){
                    this.$axios.get(this.$shopUrl+'Upload/ReadFile?url='+file.url,{
                        responseType: 'blob',
                    }).then(    
                        (response) => {
                            this.downloadFile(response.data, fileName);
                        }
                    )
                }else{
                    var a = document.createElement('a')
                    a.href = this.$imgUrl+url
                    a.download = fileName
                    document.body.appendChild(a);
                    a.click()
                    document.body.removeChild(a);
                }
            },
            downloadFile(content, filename) {
                var a = document.createElement('a')
                var blob = new Blob([content])
                var url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = filename
                document.body.appendChild(a);
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a);
            },
            onRemove(file){
                this.fileList=this.fileList.filter(function (item) {
                    return item.uid!=file.uid;
                });
            },
            closeSelf() {
                this.$emit("closeAdd");
                this.fileList=[]
            },

            handelIncrease(step) {
                this.addForm.content=step
            },
            handleSuccess(res, file) {
                var files={
                    name:file.name,
                    url:res.data.path
                }
                this.fileList.push(files);
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'warning', message: '请完善信息'});
                        return false;
                    }
                })
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Article/CommandCenterAdd",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                            this.fileList=[]
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            }

        }
    }
</script>


<style  lang="scss" scoped>
    .modal-article {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 800px;

        .modal-header {
            border-bottom: 1px solid #eee;
            color: #313131;
            justify-content: space-between;
            padding: 10px;
            display: flex;
        }
        .modal-footer {
            border-top: 1px solid #eee;
            justify-content: flex-end;
            padding: 15px;
            display: flex;
        }
        .modal-body {
            position: relative;
            padding: 20px 0px;
            z-index: 99;
            overflow-y:scroll;
            height:300px;
            .daterange /deep/ .el-form-item__content{
                margin-top: 40px;
            }
            .daterange /deep/ .lable{
                padding: 0;
            }
        }
    }
    
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }

    .fileClass{
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
